import { createSlice } from "@reduxjs/toolkit";
import { getMaxPrice } from "store/actions/Shop.action";

const initialState = {
  query: "",
  minPrice: null,
  maxPrice: null,
  rating: null,
  page: 1,
  numberOfSales: null,
  name: "",
};

const slice = createSlice({
  name: "Search",
  initialState,
  reducers: {
    updateSearchParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    retainSearchParams: (state) => {
      return {
        ...initialState,
        name: state.name,
        query: state.query,
      };
    },
    resetSearchParams: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMaxPrice.fulfilled, (state, action) => {
        console.log("punyeta",action.payload.d);
        state.maxPrice = action.payload.d;
      })
      .addCase(getMaxPrice.pending, (state) => {
        state.maxPrice = null;
      })
      .addCase(getMaxPrice.rejected, (state, action) => {
        console.error("Failed to fetch max price", action.error);
      });
  },
});

export const { updateSearchParams, retainSearchParams, resetSearchParams } =
  slice.actions;

export const { reducer: ProductSearch } = slice;

export default slice;
